import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ScreenReaderShortcuts from '@bibliocommons/base-screen-reader-shortcuts';

const mapStateToProps = state => ({
  screenReaderNavigation: state.getIn(['templates', 'screenReaderNavigation'])
});

const ScreenReaderNavigationContainer = ({ screenReaderNavigation }) => (
  <ScreenReaderShortcuts screenReaderNavigation={screenReaderNavigation} />
);

ScreenReaderNavigationContainer.displayName = 'ScreenReaderNavigationContainer';

ScreenReaderNavigationContainer.propTypes = {
  screenReaderNavigation: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(ScreenReaderNavigationContainer);
